// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { Prisma } from '@terra/prisma-orchestrator-client';

export const InputJsonValueSchema: z.ZodType<Prisma.InputJsonValue> = z.lazy(() =>
  z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.record(z.string(), z.lazy(() => z.union([InputJsonValueSchema, z.literal(null)]))),
    z.array(z.lazy(() => z.union([InputJsonValueSchema, z.literal(null)]))),
    z.object({ toJSON: z.any() }),
  ])
);

export type InputJsonValueType = z.infer<typeof InputJsonValueSchema>;

export default InputJsonValueSchema;
